export default {"src":"/_next/static/media/butterfly1.1e456117.svg","height":133,"width":118,"blurWidth":0,"blurHeight":0};